module.exports = __webpack_public_path__ + "media/images/lb/005-5593ded8ea6cd134b9dfea1e55d3b2f2.svg";